/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Evidence type for competition match disputes
 * @export
 */
export const CompetitionEvidenceType = {
    SCREENSHOT: 'SCREENSHOT',
    VIDEO: 'VIDEO',
    OVERWOLF_DATA: 'OVERWOLF_DATA',
    REPLAY: 'REPLAY'
} as const;
export type CompetitionEvidenceType = typeof CompetitionEvidenceType[keyof typeof CompetitionEvidenceType];


export function instanceOfCompetitionEvidenceType(value: any): boolean {
    for (const key in CompetitionEvidenceType) {
        if (Object.prototype.hasOwnProperty.call(CompetitionEvidenceType, key)) {
            if (CompetitionEvidenceType[key as keyof typeof CompetitionEvidenceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionEvidenceTypeFromJSON(json: any): CompetitionEvidenceType {
    return CompetitionEvidenceTypeFromJSONTyped(json, false);
}

export function CompetitionEvidenceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionEvidenceType {
    return json as CompetitionEvidenceType;
}

export function CompetitionEvidenceTypeToJSON(value?: CompetitionEvidenceType | null): any {
    return value as any;
}

export function CompetitionEvidenceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionEvidenceType {
    return value as CompetitionEvidenceType;
}

